import { CollectionEmailTemplate, TONE_LABELS } from '../config/model';

export type CollectionEmailSendStatus = 'queued' | 'sent' | 'failed';
export type CollectionEmailSendSource = 'automatic' | 'manual';
export type CollectionEmailSendSourceFilter = CollectionEmailSendSource | 'one_off';
export type CollectionEmailType = 'collection' | 'statement';

export interface CollectionEmailSendListItem {
  id: number;
  company: string;
  bill_code: string;
  location: string;
  email_type: CollectionEmailType;
  tone: CollectionEmailTemplate['tone'] | null;
  one_off: boolean;
  status: CollectionEmailSendStatus;
  send_source: CollectionEmailSendSource;
  to_emails: string[];
  delivered_at: string | null;
  triggered_by_name: string | null;
}

export interface CollectionEmailSendDetail extends CollectionEmailSendListItem {
  collections_client_id: number | null;
  subject: string;
  queued_at: string | null;
  body: string;
  reply_to_email: string;
  sender_display_name: string;
  attachment_metadata: { edoc_invoice_import_id: number; filename: string }[];
  error_message: string | null;
}

export interface CollectionEmailSendsResponse {
  total_records: number;
  page: number;
  per_page: number;
  result: CollectionEmailSendListItem[];
}

export const STATUS_LABELS: Record<CollectionEmailSendStatus, string> = {
  queued: 'Queued',
  sent: 'Sent',
  failed: 'Failed',
};

export const SOURCE_LABELS: Record<CollectionEmailSendSource, string> = {
  automatic: 'Automatic',
  manual: 'Manual',
};

export const SOURCE_FILTER_LABELS: Record<CollectionEmailSendSourceFilter, string> = {
  automatic: 'Automatic',
  manual: 'Manual',
  one_off: 'One-Off',
};

export const MODULE_LABELS: Record<CollectionEmailType, string> = {
  collection: 'Collection',
  statement: 'Statement',
};

export const NO_TONE_FILTER_VALUE = 'no_tone';

export function getModuleLabel(emailType: CollectionEmailType): string {
  return MODULE_LABELS[emailType];
}

export function getToneLabel(row: Pick<CollectionEmailSendListItem, 'tone'>): string {
  if (!row.tone) return 'No Tone';
  return TONE_LABELS[row.tone];
}

export function getSourceLabel(row: Pick<CollectionEmailSendListItem, 'one_off' | 'send_source'>): string {
  if (row.one_off) return SOURCE_FILTER_LABELS.one_off;
  return SOURCE_LABELS[row.send_source];
}
